import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    outAndAboutId: Number,
  };
  static targets = ["more"];
  connect() {
    console.log("Location Select Connected");
  }

  update(event) {
    const changedValue = parseInt(event.detail.value, 10);

    if (changedValue === this.outAndAboutIdValue) {
      this.moreTarget.classList.remove("hidden");
    } else {
      this.moreTarget.classList.add("hidden");
    }
  }
}
